<!-- 项目缺陷分布 -->
<template>
  <a-card title="项目缺陷分布" size="small">
    <span v-if="false" slot="extra">
      <a-radio-group default-value="week" button-style="solid" size="small">
        <a-radio-button value="week"> 周 </a-radio-button>
        <a-radio-button value="month"> 月 </a-radio-button>
      </a-radio-group>
    </span>
    <div id="project-defect" :style="{ height: height, width: width }" />
  </a-card>
</template>
<script>
import { qualityProjectDefect } from '@/api/data/quality';
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    startDate: {
      type: String,
      default: null
    },
    endDate: {
      type: String,
      default: null
    },
    projects: {
      type: [Array, String],
      default: null
    }
  },
  data() {
    return {
      myChart: null,
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        legend: {},
        yAxis: {},
        series: []
      },
      xAxisData: [],
      series: []
    };
  },
  computed: {
    filter() {
      const { startDate, endDate, projects } = this;
      return {
        startDate,
        endDate,
        projects
      };
    }
  },
  watch: {
    filter() {
      this.getProjectDefectData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 柱状图
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    this.myChart = echarts.init(document.getElementById('project-defect'));
    this.getProjectDefectData();
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option, true);
      window.addEventListener('resize', () => {
        if (this.myChart) {
          this.myChart.resize();
        }
      });
    },
    getProjectDefectData() {
      const requestData = { start_date: this.startDate, end_date: this.endDate, projects: this.projects };
      qualityProjectDefect(requestData).then(res => {
        this.option.xAxis.data = res.data.x_axis;
        this.option.series = res.data.series.map(project => {
          return {
            name: project.project_name,
            type: 'bar',
            label: {
              show: true,
              position: 'top'
            },
            data: project.data
          };
        });
        this.drawChart();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
</style>
